import {
  createStartAction,
  createFailAction,
  createSuccessAction,
} from '../redux-util/async-helpers';
import { CREATE_PAGE_VIEWER, DESTROY } from './jigsaw-methods';
import * as events from './jigsaw-events';
import { createJigsawEventAction } from './jigsaw-action';
import * as triggers from './jigsaw-auto-triggers';
import { callApiByName } from '../jigsaw-proxy';
import { tryRedirectJigsawFailure } from '../redux-route/route-actions';
import { getErrorContent } from '../jigsaw-helpers';
import { once } from '../../utils/func';

function getCallback(store, apiCall, args, resolve) {
  return once(function(response) {
    if (response.isSuccess()) {
      store.dispatch(createSuccessAction(apiCall, response.data, args));
      const autoTriggers = triggers.methods[apiCall];
      if (autoTriggers) {
        autoTriggers.forEach(t => store.dispatch(t));
      }
      resolve({ success: true });
    } else {
      const normalizedError = getErrorContent(response);
      store.dispatch(createFailAction(apiCall, normalizedError, args));
      store.dispatch(tryRedirectJigsawFailure(normalizedError, apiCall));
      resolve({ success: false });
    }
  });
}

function getViewer() {
  return window.watsonViewer;
}

function setViewer(viewer) {
  window.watsonViewer = viewer;
}

function tryCleanUpOldPageViewer(apiCall) {
  if (apiCall === DESTROY && getViewer()) {
    setViewer(null);
  }
}

function trySetUpNewPageViewer(apiCall, result, dispatch) {
  if (apiCall === CREATE_PAGE_VIEWER) {
    setViewer(result);
    Object.keys(events).forEach(name => {
      const eventName = events[name];
      getViewer().bind(eventName, (event, data) => {
        const myEvent = createJigsawEventAction(eventName);
        dispatch(myEvent(data));
        const toRun = triggers.events[eventName];
        if (toRun) {
          toRun.forEach(f => dispatch(f));
        }
      });
    });
  }
}

export default store => next => action => {
  if (!action.jigsaw) {
    // Normal action: pass it on
    return next(action);
  }

  if (action.jigsaw.apiCall) {
    return new Promise(resolve => {
      const apiCall = action.jigsaw.apiCall;
      const apiContext = action.jigsaw.targetReader ? getViewer() : window;
      tryCleanUpOldPageViewer(apiCall);
      store.dispatch(createStartAction(apiCall, action.jigsaw.args));
      const apiResult = callApiByName(
        apiCall,
        apiContext,
        action.jigsaw.args,
        getCallback(store, apiCall, action.jigsaw.args, resolve)
      );
      trySetUpNewPageViewer(apiCall, apiResult, store.dispatch);
    });
  }

  // This resolves because in a redux context we can end up with lots
  // of uncaught in promise exceptions there's not a great way to handle,
  // since rejections are ok and handled through redux
  return Promise.resolve({
    success: false,
  });
};



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/jigsaw-middleware.js